<template>
  <div class="sso-tabs">
    <router-link to="/solution/sso" class="sso-tab" :class="{ active: current === 'sso' }">
      {{ $t('solution.title.sso') }}
    </router-link>
    <router-link to="/solution/isign" class="sso-tab" :class="{ active: current === 'isign' }">
      {{ $t('solution.title.isign') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SsoTabs',
  props: {
    current: {
      type: String,
      required: true
    }
  }
}
</script>
